import { useState, useEffect, Dispatch, SetStateAction } from "react";

export const useAccessibilityInfoShown = (): [boolean, Dispatch<SetStateAction<boolean>>] => {
  const [accessibilityInfoShown, setAccessibilityInfoShown] = useState(false)

  return [accessibilityInfoShown, setAccessibilityInfoShown]
}

export default useAccessibilityInfoShown;